module.exports = __webpack_public_path__ + "img/iOS_miaoshu.789e62b6.png";